// Arquivo: src/pages/Home.tsx  (colar o conteúdo INTEGRAL no Code Mode)
// Porta de entrada com o login visual FIXO mantido por decisão do proprietário
// (mesmas credenciais do APP RDR atual). Visual igual ao app local:
// card branco sobre fundo navy, e-mail e senha, mostrar/ocultar senha.

import { useAuth } from '@/hooks/useAuth'
import { useState } from 'react'
import EngineeringDashboard from '@/components/EngineeringDashboard'

export default function Home() {
  const { isAuthenticated, login, signOut } = useAuth()
  const [email, setEmail] = useState('adm@rdrengenharia.com')
  const [senha, setSenha] = useState('')
  const [mostrarSenha, setMostrarSenha] = useState(false)
  const [error, setError] = useState('')
  const [shake, setShake] = useState(false)

  if (!isAuthenticated) {
    const submit = (event: React.FormEvent) => {
      event.preventDefault()
      if (login(email, senha)) {
        setError('')
        return
      }
      setError('E-mail ou senha incorretos.')
      setShake(true)
      setSenha('')
      setTimeout(() => setShake(false), 400)
    }
    return (
      <div className="login-overlay">
        <div className={`login-card ${shake ? 'shake-card' : ''}`}>
          <div className="login-logo"><span className="logo-pill"><span className="logo-emblem">RDR</span> RDR ENGENHARIA</span></div>
          <h1 className="login-title">Entrar no Sistema</h1>
          <p className="login-sub">Use seu e-mail e senha para continuar.</p>
          <form onSubmit={submit}>
            {error ? <div className="login-error">{error}</div> : null}
            <div className="field-wrap">
              <span className="field-icon">✉</span>
              <input
                type="email"
                className="login-input"
                placeholder="E-mail"
                value={email}
                autoFocus
                onChange={event => setEmail(event.target.value)}
              />
            </div>
            <div className="field-wrap">
              <span className="field-icon">🔒</span>
              <input
                type={mostrarSenha ? 'text' : 'password'}
                className="login-input"
                placeholder="Senha"
                value={senha}
                onChange={event => setSenha(event.target.value)}
              />
              <button type="button" className="field-eye" onClick={() => setMostrarSenha(value => !value)} aria-label="Mostrar/ocultar senha">
                {mostrarSenha ? '🙈' : '👁'}
              </button>
            </div>
            <button type="submit" className="btn-login">Entrar</button>
            <div className="login-hint">Acesso: <strong>adm@rdrengenharia.com</strong> • Senha: <strong>admin123</strong></div>
          </form>
          <div className="login-footer">v2.0 • © 2026 Todos os direitos reservados</div>
        </div>
      </div>
    )
  }

  return <EngineeringDashboard role="admin" email={email} onSignOut={signOut} />
}
